import { render, staticRenderFns } from "./omniaImageUploader.vue?vue&type=template&id=01e0160b&scoped=true&"
import script from "./omniaImageUploader.vue?vue&type=script&lang=js&"
export * from "./omniaImageUploader.vue?vue&type=script&lang=js&"
import style0 from "./omniaImageUploader.vue?vue&type=style&index=0&id=01e0160b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e0160b",
  null
  
)

export default component.exports